import { request, API_V1_PREFIX } from "./client";
import type { DashboardOverview } from "./types";

export async function getDashboardOverview(token: string, schoolProfileId?: string): Promise<DashboardOverview> {
  const query = schoolProfileId ? `?school_profile_id=${schoolProfileId}` : "";
  return request<DashboardOverview>(`${API_V1_PREFIX}/dashboard/overview${query}`, { method: "GET" }, { token });
}

export async function generateLesson(payload: unknown): Promise<any> {
  return request<any>(
    `${API_V1_PREFIX}/generate-lesson`,
    {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(payload),
    },
    {},
  );
}

export async function generateSlides(payload: unknown): Promise<any> {
  return request<any>(
    `${API_V1_PREFIX}/generate-slides`,
    {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(payload),
    },
    {},
  );
}
